import { type FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface SummaryRowProps {
  label: string
  value: string
  bold?: boolean
}

export const SummaryRow: FC<SummaryRowProps> = ({ label, value, bold }) => (
  <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
    <Text size="200" color="grey700">
      {label}
    </Text>
    <Text size="200" weight={bold ? 'semibold' : 'normal'} color={bold ? 'grey1000' : 'grey700'}>
      {value}
    </Text>
  </Box>
)
